module.exports = __webpack_public_path__ + "img/location_boy.6ca963dd.png";